document.addEventListener("DOMContentLoaded", function () {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > 0) {
                setTimeout(() => {
                    entry.target.classList.add("intersected");
                }, 250);
            }
        });
    });

    [...document.querySelectorAll(".intersect-start")].forEach((element) => {
        observer.observe(element);
    });
});
